import { useQuery } from '@tanstack/react-query'

import queries from '@/api/queries'
import statusResources from '@/api/status'

const useSetup = () =>
  useQuery(queries.status(), statusResources.get, {
    staleTime: Infinity,
  }).data?.setup

export default useSetup
